module.exports = __webpack_public_path__ + "static/media/Piercing-nipple-symmetry.285d1976.png";